export const PATH = {
    home: '/',
    login: '/login',
    signUp: '/sign-up',
    signUpSuccess: '/sign-up/verify',
    forgotPasswordSuccess: '/reset/verify',
    forgotPassword: '/forgot',
    resetPassword: '/reset',
    verifyEmail: '/verify',
    dashboard: '/dashboard',
    login2fa: '/login2fa',
    settings: '/settings',
    aggregateBalance: '/aggregate-balance',
    generalInformation: '/settings/general',
    twoFactorAuth: '/settings/2factor-auth',
    changePassword: '/settings/change-password',
    wallets: '/settings/wallets',
    users: '/users',
    userShow: '/user/:id',
    plans: '/plans',
    ranks: '/ranks',
    withdraw: '/withdraw',
    coins: '/coins',
    discounts: '/discounts',
};
